'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiGrid = exports.default = undefined;

var _MultiGrid2 = require('./MultiGrid');

var _MultiGrid3 = _interopRequireDefault(_MultiGrid2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MultiGrid3.default;
exports.MultiGrid = _MultiGrid3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/commonjs/MultiGrid/index.js
// module id = ./node_modules/react-virtualized/dist/commonjs/MultiGrid/index.js
// module chunks = 0